/**
 * 注册弹窗底部按钮栏
 * - 上一步（步骤 2-4）、各步骤主操作按钮（同意并继续/验证并下一步/继续注册/提交注册）
 * - 按钮禁用与文案逻辑与原主控制器完全一致
 */
import { Loader2 } from 'lucide-react';
import type { RegisterStep, SystemCheckResult, IdentityVerificationState } from '../../../../../stores/registerStore';

export function ModalFooter({
  currentStep,
  agreed,
  hasReadToBottom,
  registerCountdown,
  identityVerification,
  step3CanContinue,
  systemCheckResult,
  releaseToken,
  smsCode,
  submitting,
  onPrev,
  onNext,
  onContinue,
}: {
  currentStep: RegisterStep;
  agreed: boolean;
  hasReadToBottom: boolean;
  registerCountdown: number;
  identityVerification: IdentityVerificationState;
  step3CanContinue: boolean;
  systemCheckResult: SystemCheckResult | null;
  releaseToken: string | null;
  smsCode: string;
  submitting: boolean;
  onPrev: () => void;
  onNext: () => void;
  onContinue: () => void;
}) {
  return (
    <div className="p-6 flex gap-3 flex-shrink-0 border-t border-slate-100">
      {currentStep > 1 && currentStep < 5 && (
        <button
          onClick={onPrev}
          className="flex-1 py-3 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
        >
          上一步
        </button>
      )}

      {currentStep === 1 && (
        <button
          onClick={onNext}
          disabled={!agreed || !hasReadToBottom || registerCountdown > 0}
          className="flex-1 py-3 bg-teal-600 hover:bg-teal-700 disabled:bg-slate-300 text-white text-sm font-medium rounded-lg transition-colors"
        >
          {registerCountdown > 0 ? `${registerCountdown}秒后可继续` : '同意并继续'}
        </button>
      )}

      {currentStep === 2 && (
        <button
          onClick={onNext}
          disabled={identityVerification.isLoading}
          className="flex-1 py-3 bg-teal-600 hover:bg-teal-700 disabled:bg-slate-300 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
        >
          {identityVerification.isLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              正在实名核验...
            </>
          ) : identityVerification.isVerified ? (
            '下一步'
          ) : (
            '验证并下一步'
          )}
        </button>
      )}

      {currentStep === 3 && step3CanContinue && (
        <button
          onClick={onContinue}
          disabled={(!!systemCheckResult?.releaseRequired && !releaseToken) || (systemCheckResult?.phoneChanged && smsCode.length !== 6)}
          className="flex-1 py-3 bg-teal-600 hover:bg-teal-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white text-sm font-medium rounded-lg transition-colors"
        >
          {systemCheckResult?.releaseRequired && !releaseToken
            ? '请先完成短信验证'
            : systemCheckResult?.phoneChanged && smsCode.length !== 6
            ? '请先完成新手机号验证'
            : '继续注册'}
        </button>
      )}

      {currentStep === 4 && (
        <button
          onClick={onNext}
          disabled={submitting}
          className="flex-1 py-3 bg-teal-600 hover:bg-teal-700 disabled:bg-slate-300 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
        >
          {submitting ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              提交中...
            </>
          ) : (
            '提交注册'
          )}
        </button>
      )}
    </div>
  );
}